import {Grid} from '@mui/material';
import styles from 'assets/css/wizard.module.css';
import profSvg from 'assets/img/proff.svg';
import BackButton from './BackButton';

const Header = ({title, inParentheses, backStepHandler, activeStep}) => {
  return (
    <Grid item xs={12}>
      <Grid container xs={12} className={styles.header}>
        <Grid item xs={1}>
          <img src={profSvg} />
        </Grid>
        <Grid item xs={10} textAlign={'center'} className={styles.title}>
          {title}
          {inParentheses && (
            <span style={{color: '#979797'}}>{` (${inParentheses})`}</span>
          )}
        </Grid>
        <Grid item xs={1} textAlign={'left'}>
          {activeStep === 2 && <BackButton backStepHandler={backStepHandler} />}
        </Grid>
      </Grid>
      <div
        className={styles.border}
        style={{
          width: `${title?.length + inParentheses?.length - 3}ch`,
        }}
      />
    </Grid>
  );
};

export default Header;
